module.exports = __webpack_public_path__ + "img/20201207.0cb523a1.png";